export default __webpack_public_path__ + "static/media/blue_4.85828b1d.png";